module.exports = __webpack_public_path__ + "img/6.12948252.png";